import { PotentiallyUnsafeInnerHtml } from "@/components/potentially-unsafe-inner-html"
import { Substance } from "@/modules/patients/detail/medication/de/search-results"

interface SubstanceSelectionProps {
  substance: Substance
}

const SubstanceSelection = ({ substance }: SubstanceSelectionProps) => {
  return (
    <div className="border-border mb-8 rounded-lg border px-4 py-2" data-testid="substance-selection">
      <div className="flex items-center">
        <div className="grid items-center">
          <PotentiallyUnsafeInnerHtml
            className="text-on-surface inline text-sm leading-6 font-medium"
            value={substance.nameHtml}
          />
        </div>
      </div>
    </div>
  )
}

export { SubstanceSelection }
